import React from 'react';
interface DonutProps {
  odstotek: number | null;
  color: string;
  size?: number;
  label?: string;
}
export function Donut({
  odstotek,
  color,
  size = 92,
  label
}: DonutProps) {
  const r = (size - 10) / 2;
  const c = 2 * Math.PI * r;
  const val = odstotek ?? 0;
  return <div className="relative inline-flex items-center justify-center" style={{
    width: size,
    height: size
  }} data-id="element-429" data-mp="2osusphivkq2j">
      <svg width={size} height={size} className="-rotate-90" aria-hidden="true" data-id="element-430" data-mp="2ts7dzxu3lp30">
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="#e5e9e8" strokeWidth="8" data-id="element-431" data-mp="2tq4p5h4om1zv" />
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke={color} strokeWidth="8" strokeLinecap="round" strokeDasharray={c} strokeDashoffset={c - c * val / 100} style={{
        transition: 'stroke-dashoffset 300ms cubic-bezier(0.23,1,0.32,1)'
      }} data-id="element-432" data-mp="2xr6i5g809hte" />
      </svg>
      <div className="absolute text-center" data-id="element-433" data-mp="3hi1tyo9prtrh">
        <span className="block text-lg font-semibold leading-none text-ink" data-id="element-434" data-mp="24giqosxz2e3b">
          {odstotek === null ? '—' : `${odstotek}%`}
        </span>
        {label && <span className="mt-0.5 block text-[10px] text-ink-muted" data-id="element-435" data-mp="1zge5wqq16x7a">{label}</span>}
      </div>
    </div>;
}